/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path context
 * @description Scroll context implementation
 */
import create from "zustand";
export type ElementInfo = {
  el: any;
  key: string;
  parentNode?: any;
};
export interface ScrollPositionStore {
  scrollY: number;
  activeScrollElement: ElementInfo | null;
  elementPositions: Map<any, number>;
  activeElements: Map<any, ElementInfo>;
  setY: (y: number) => void;
  setActiveIndex: (i: any) => void;
  addElement: (el: ElementInfo) => void;
  resetElements: () => void;
  setElementPosition: (el: string, y: number) => void;
  scrollTo: (key: string) => void;
}
const getScrollParent = (node: any): any => {
  if (node == null || node.tagName === "BODY") {
    return null;
  }
  if (node.scrollHeight > node.clientHeight) return node;
  return getScrollParent(node.parentNode);
};
export const createStore = () =>
  create<ScrollPositionStore>((set, get) => ({
    // window scroll position
    scrollY: 0,
    activeScrollElement: null,
    elementPositions: new Map<any, number>(),
    activeElements: new Map<any, ElementInfo>(),
    setY: (y) => {
      //  console.log('Set Y', y);
      //  console.log('enteries', get().activeElements.entries());
      // for example y
      const list: Array<{
        elem: ElementInfo;
        y: number;
      }> = [];
      const entries = get().activeElements.entries();
      let v = entries.next();
      while (v && !v.done) {
        const [el, info] = v.value;
        const elemY = get().elementPositions.get(el);
        //  console.log('Set Y elem y ', elemY);
        if (typeof elemY !== "undefined") {
          list.push({ y: elemY, elem: info });
        }
        v = entries.next();
      }
      list.sort((a, b) => a.y - b.y);
      //  console.log(list);
      const visibleCandidates = list.filter((item) => item.y >= 0);
      if (list.length === 0) {
        return;
      }
      //  console.log('Visible candidates ', visibleCandidates);
      if (visibleCandidates.length === 0) {
        //  console.log('Setting ', list[list.length - 1].elem);
        set({ activeScrollElement: list[list.length - 1].elem });
      } else {
        //  console.log('activeScrollElement ', visibleCandidates[0].elem);
        const activeListCandidate = list.find((candidate) => candidate.y <= 0);
        const activeCandidate = activeListCandidate
          ? [...list].reverse().find((candidate) => candidate.y <= 300)
          : undefined;
        set({
          activeScrollElement:
            activeCandidate?.elem || visibleCandidates[0].elem,
        });
      }
      set({ scrollY: y });
    },
    scrollTo: (key: string) => {
      const el = get().activeElements.get(key);
      const elPos = get().elementPositions.get(key);
      const entries = get().elementPositions.entries();
      const positions = Array.from(entries).map(
        ([key, value]) => value + get().scrollY
      );
      const minY = Math.min(...positions);
      //  console.log('positions', positions, get().scrollY);
      if (el && elPos) {
        const scrollParent = getScrollParent(el?.el?.parentNode);
        if (scrollParent) {
          scrollParent.scrollTo({
            top: elPos - minY + 100,
            left: 0,
            behavior: "smooth",
          });
        } else {
          window.scrollBy({
            top: elPos - minY,
            left: 0,
            behavior: "smooth",
          });
        }
      } else {
        console.log(" scroll position not found ", key);
      }
    },
    setActiveIndex: (i) => {
      set({ activeScrollElement: i });
    },
    setElementPosition: (name: string, y: number) => {
      //  console.log('Set Element Y', name, y);
      set({ elementPositions: new Map(get().elementPositions).set(name, y) });
    },
    addElement: (el: ElementInfo) => {
      //  console.log('Add element ', el);
      set({ activeElements: new Map(get().activeElements).set(el.key, el) });
    },
    resetElements: () => {
      set({
        activeElements: new Map(),
        elementPositions: new Map(),
      });
      //  console.log('************** RESET ELEMENTS **********************');
    },
  }));
